import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Import Containers
import { DefaultLayoutComponent } from './containers';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'loading',
    pathMatch: 'full',
  }
  ,
      {
        path: 'login',
        loadChildren: './login/login.module#LoginModule'
      }
  ,
  {
    path: 'loading',
    loadChildren: './loading/loading.module#LoadingModule'
  }
,
  
  {
    path: '',
    component: DefaultLayoutComponent,
    data: {
      title: 'Home'
    },
    children: [
      {
        path: 'dashboard',
        loadChildren: './views/dashboard/dashboard.module#DashboardModule'
      },
      {
        path: 'cadastro',
        loadChildren: './views/cadastro/cadastro.module#CadastroModule'
      },
      {
        path: 'guia',
        loadChildren: './views/guia/guia.module#GuiaModule'
      },
      {
        path: 'agenda',
        loadChildren: './views/agenda/agenda.module#AgendaModule'
      },
      {
        path: 'prestador',
        loadChildren: './views/prestador/prestador.module#PrestadorModule'
      },
      {
        path: 'enfermeira',
        loadChildren: './views/enfermeira/enfermeira.module#EnfermeiraModule'
      },
      {
        path: 'terceiro',
        loadChildren: './views/terceiro/terceiro.module#TerceiroModule'
      },
      {
        path: 'encaminhar',
        loadChildren: './views/encaminhar/encaminhar.module#EncaminharModule'
      },
      {
        path: 'tabelaReferencia',
        loadChildren: './views/tabelaReferencia/tabelaReferencia.module#TabelaReferenciaModule'
      },
      {
        path: 'empresa',
        loadChildren: './views/empresa/empresa.module#EmpresaModule'
      },
      {
        path: 'email',
        loadChildren: './views/email/email.module#EmailModule'
      },
      {
        path: 'notificacao',
        loadChildren: './views/notificacao/notificacao.module#NotificacaoModule'
      },
      {
        path: 'configuracoes',
        loadChildren: './views/configuracoes/configuracoes.module#ConfiguracoesModule'
      },
      {
        path: 'consultaExtraEnfermeira',
        loadChildren: './views/consulta-extra-enfermeira/consulta-extra-enfermeira.module#ConsultaExtraEnfermeiraModule'
      },
      {
        path: 'consultaExtraAdministrador',
        loadChildren: './views/consulta-extra-administrador/consulta-extra-administrador.module#ConsultaExtraAdministradorModule'
      },
      {
        path: 'voucher',
        loadChildren: './views/voucher/voucher.module#VoucherModule'
      }
    ]
  }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}
